export interface IGraphData {
    hasMismatchCount: boolean,
    estimatedWaitMmIntermediate: number,
    estimatedWaitMmLow: number,
    estimatedWaitMmNone: number, 
    xAxis_Eplet: number[],
    yAxis_Eplet: number[]
}